import { Environment, Url } from '@atlassiansox/bxpkit-core';
import Cookies from 'js-cookie';
// TODO: break this into ./utility?
import { isTestTenantByName } from '../../../service/sign-up-form/form-submit';
import { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

type GetSignupContextType = {
  readonly cloudName: string;
  readonly createAnalyticsEvent: CreateUIAnalyticsEvent;
};

export function getSignupContext({
  cloudName,
  createAnalyticsEvent
}: GetSignupContextType): string | undefined {
  const MAX_SIGNUP_CONTEXT_LENGTH = 8192;
  const signupContext = {};
  const queryParameters = Url.getUrlParams() || {};
  const templateId = queryParameters.hasOwnProperty('templateId')
    ? queryParameters.templateId
    : null;

  if (templateId) {
    Object.assign(signupContext, { templateId });
  }
  if (isTestTenantByName(!Environment.isProduction(), cloudName)) {
    Object.assign(signupContext, { testingPurposes: true });
  }

  const bxpGatewayAnchorCookie = Cookies.get('bxp_gateway_anchor') || '';
  if (bxpGatewayAnchorCookie) {
    try {
      const bxpGatewayAnchor = JSON.parse(bxpGatewayAnchorCookie);
      if (bxpGatewayAnchor) {
        bxpGatewayAnchor.timestamp = new Date();
        Object.assign(signupContext, { bxpGatewayAnchor });
      }
    } catch (error) {
      createAnalyticsEvent({
        eventName: 'bxp.anchorJourney.parseCookieError'
      }).fire();
    }
  }

  const signupContextString = JSON.stringify(signupContext);

  if (signupContextString.length <= MAX_SIGNUP_CONTEXT_LENGTH) {
    return signupContextString;
  } else {
    // newRelic.action(
    //   'bxp.formCloudSignup.signupContextTooLarge',
    //   signupContextString.length.toString()
    // );
    // TODO: signup context too large with createAnalyticsEvent
    return;
  }
}
